var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificateborder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 421,
    viewBox: "0 0 615 421",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.86415 5.25488H6.63672V6.4825",
    stroke: "#F2542D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63672 8.9458V412.653",
    stroke: "#F2542D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.02 3.02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63672 413.881V415.109H7.86415",
    stroke: "#F2542D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3105 415.109H605.919",
    stroke: "#F2542D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.99 2.99"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M607.139 415.109H608.366V413.881",
    stroke: "#F2542D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M608.365 411.418V7.71826",
    stroke: "#F2542D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.02 3.02"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M608.366 6.4825V5.25488H607.139",
    stroke: "#F2542D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M604.693 5.25488H9.08398",
    stroke: "#F2542D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.99 2.99"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.1328V410.231H614.504V10.1328H0.5Z",
    stroke: "#F2542D",
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2832 0.5V419.864H601.724V0.5H13.2832Z",
    stroke: "#F2542D",
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1936 409.765H13.2988V401.008H22.1936V409.765Z",
    stroke: "#F2542D",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4855 407.105H16.0078V403.676H19.4855V407.105Z",
    fill: "#F2542D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M601.779 409.765H592.893V401.008H601.779V409.765Z",
    fill: "#FEFFFF",
    stroke: "#F2542D",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M598.58 404.176V406.604H596.094V404.176H598.58Z",
    fill: "#FEFFFF",
    stroke: "#F2542D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1936 18.898H13.2988V10.1328H22.1936V18.898Z",
    stroke: "#F2542D",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4855 16.2299H16.0078V12.8008H19.4855V16.2299Z",
    fill: "#F2542D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M601.779 18.898H592.893V10.1328H601.779V18.898Z",
    stroke: "#F2542D",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M599.08 16.2299H595.594V12.8008H599.08V16.2299Z",
    fill: "#F2542D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateborder);
export default __webpack_public_path__ + "static/media/certificate border.af015c5e608078c7a201b6bf8d163527.svg";
export { ForwardRef as ReactComponent };